module.exports = __webpack_public_path__ + "img/banner2关于我们.95b33f7e.jpg";